import { Button, Descriptions, Divider, Space, Tag } from "antd";
import { ArrowLeftOutlined, RedoOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useKycQuestionnaireSendDetail } from "./useKycQuestionnaireSendDetail";
import { ResponseView } from "./responseView";

const statusColors: Record<string, string> = {
  PENDING: "orange",
  COMPLETED: "green",
  EXPIRED: "red",
};
const statusLabels: Record<string, string> = {
  PENDING: "Хүлээгдэж буй",
  COMPLETED: "Бөглөсөн",
  EXPIRED: "Хугацаа дууссан",
};

export const KycQuestionnaireSendDetailWidget = ({
  _id,
}: {
  _id: string;
}) => {
  const { data, loading, resend } = useKycQuestionnaireSendDetail({ _id });

  return (
    <>
      <div className="page-header">
        <h3>Илгээмж дэлгэрэнгүй</h3>
        <Space>
          <Button
            icon={<RedoOutlined />}
            onClick={resend}
            loading={loading}
          >
            Дахин илгээх
          </Button>
          {data?.questionnaire?._id && (
            <Link
              to={`/kyc-questionnaires/detail/${data.questionnaire._id}`}
            >
              <Button type="dashed" icon={<ArrowLeftOutlined />}>
                Буцах
              </Button>
            </Link>
          )}
        </Space>
      </div>

      {data && (
        <>
          <Descriptions
            bordered
            column={1}
            size="small"
            style={{ marginBottom: 24 }}
          >
            <Descriptions.Item label="Судалгаа">
              {data.questionnaire?.name ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Хэрэглэгч">
              {data.user
                ? `${data.user.lastName ?? ""} ${data.user.firstName ?? ""}`
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Утас">
              {data.user?.phoneNo ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Имэйл">
              {data.user?.email ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Төлөв">
              <Tag color={statusColors[data.status] ?? "default"}>
                {statusLabels[data.status] ?? data.status}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Илгээсэн">
              {data.sentAt
                ? new Date(data.sentAt).toLocaleString("mn-MN")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Бөглөсөн">
              {data.completedAt
                ? new Date(data.completedAt).toLocaleString("mn-MN")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Мэдэгдэл илгээгдсэн">
              {data.notificationSent ? "Тийм" : "Үгүй"}
            </Descriptions.Item>
            <Descriptions.Item label="Илгээсэн админ">
              {data.sentBy
                ? `${data.sentBy.lastName ?? ""} ${data.sentBy.firstName ?? ""}`
                : "-"}
            </Descriptions.Item>
          </Descriptions>

          {data.response && (
            <>
              <Divider />
              <h4>Хариулт</h4>
              <ResponseView
                answers={data.response.answers}
                questions={data.response.questionnaire?.questions ?? []}
              />
            </>
          )}
        </>
      )}
    </>
  );
};
